import { POSITION_TYPE } from "../common/contants"

// theme constant
export const gridSpacing = 3
export const gridSpacingForm = 2
export const drawerWidth = 260
export const appDrawerWidth = 320

export const config = {
  // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
  basename: '/eLog',
  defaultPath: '/dashboard/index',
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12
}

export const PERMISSION = {
  ADMIN: POSITION_TYPE.admin,
  KETOAN: POSITION_TYPE.accountant,
  SALE: POSITION_TYPE.sale,
  QUANLY: POSITION_TYPE.manager
}
